import { render, staticRenderFns } from "./gaincode.vue?vue&type=template&id=68007472&scoped=true&"
import script from "./gaincode.vue?vue&type=script&lang=js&"
export * from "./gaincode.vue?vue&type=script&lang=js&"
import style0 from "./gaincode.vue?vue&type=style&index=0&id=68007472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68007472",
  null
  
)

export default component.exports